<template>
    <div class="note-form d-flex flex-column">
        <div class="form-group">
            <label for="author">Autor</label>
            <input
                type="text"
                name="author"
                id="author"
                disabled="true"
                class="form-control"
                :value="!!supervisor ? supervisor.name : user.name"
            />
        </div>
        <app-form-select-input
            v-if="clientRequired"
            label="Punto de acceso"
            :options="accessPoints"
            v-model="accessPointId"
            :hasError="$v.accessPointId.$error"
            errorMessage="Debe seleccionar el punto de acceso"
            @change="$v.accessPointId.$touch()"
        />
        <app-form-select-input
            placeholder="Tipo de anotación"
            :options="annotationTypes"
            v-model="annotationType"
            :is-object="true"
            :hasError="$v.annotationType.$error"
            errorMessage="Debe seleccionar el tipo de anotación"
            @change="noteTypeChange(!!annotationType ? annotationType.id : '')"
        />
        <div v-if="showControlPointField" class="form-group" style="max-width: 300px;">
            <app-form-datetime
                label="Fecha y Hora"
                id="note-datetime"
                v-model="noteDateTime"
                :required="true"
                :hasError="$v.noteDateTime.$error"
                errorMessage="Debe seleccionar la fecha y hora"
                @input="$v.noteDateTime.$touch()"
            />
        </div>
        <div v-if="showControlPointField" class="form-group">
            <app-autocomplete-v3
                label="Área o lugar"
                :items="clientAreasWithOther"
                :value="clientAreaId"
                :required="true"
                keyProp="id"
                labelProp="name"
                :getObject="false"
                @change="onClientAreaChange"
            />
            <span v-if="$v.clientAreaId.$error" class="field-error">
                Debe seleccionar el área o lugar
            </span>
        </div>
        <div v-if="showControlPointField && clientAreaId === 'otro'" class="form-group">
            <label for="client-area-other">
                Especifique el área o lugar
                <span class="field-required-mark">*</span>
            </label>
            <input
                type="text"
                id="client-area-other"
                name="client-area-other"
                class="form-control"
                v-model.trim="clientAreaOther"
                @input="$v.clientAreaOther.$touch()"
                placeholder="Ingrese el área o lugar"
            />
            <span v-if="$v.clientAreaOther.$error" class="field-error">
                Debe especificar el área o lugar
            </span>
        </div>
        <div v-if="showControlPointField" class="form-group">
            <app-form-select-input
                :label="'Tipo de ' + (annotationType && annotationType.slug === 'incidente' ? 'Incidente' : 'Riesgo')"
                :options="incidentRiskTypesWithOther"
                v-model="incidentRiskTypeId"
                :is-object="false"
                :hasError="$v.incidentRiskTypeId.$error"
                errorMessage="Debe seleccionar el tipo"
                @change="onIncidentRiskTypeChange"
                :required="true"
            />
        </div>
        <div v-if="showControlPointField && incidentRiskTypeId === 'otro'" class="form-group">
            <label for="incident-risk-type-other">
                Especifique el tipo de {{ annotationType && annotationType.slug === 'incidente' ? 'incidente' : 'riesgo' }}
                <span class="field-required-mark">*</span>
            </label>
            <input
                type="text"
                id="incident-risk-type-other"
                name="incident-risk-type-other"
                class="form-control"
                v-model.trim="incidentRiskTypeOther"
                @input="$v.incidentRiskTypeOther.$touch()"
                placeholder="Ingrese el tipo"
            />
            <span v-if="$v.incidentRiskTypeOther.$error" class="field-error">
                Debe especificar el tipo
            </span>
        </div>
        <div v-if="showControlPointField" class="form-group">
            <label for="incident-risk-description">
                Describa lo ocurrido
                <span class="field-required-mark">*</span>
            </label>
            <small class="form-text text-muted d-block mb-2">
                ¿Qué Pasó? ¿Quien lo hizo o sobre quien ocurrió? ¿Cómo Sucedió?
            </small>
            <textarea
                id="incident-risk-description"
                name="incident-risk-description"
                class="form-control"
                rows="4"
                v-model.trim="incidentRiskDescription"
                @input="$v.incidentRiskDescription.$touch()"
                placeholder="Describa detalladamente lo ocurrido..."
            ></textarea>
            <span v-if="$v.incidentRiskDescription.$error" class="field-error">
                Debe describir lo ocurrido
            </span>
        </div>
        <div v-if="annotationType">
            <b-row>
                <b-col cols="12" md="6" lg="3">
                    <b-btn
                        v-b-toggle.collapse1
                        variant="primary"
                        class="btn-block"
                        ><i class="fa fa-plus" aria-hidden="true"></i> Agregar
                        fotos</b-btn
                    >
                </b-col>
            </b-row>
            <b-collapse id="collapse1" class="mt-2">
                <b-row>
                    <b-col cols="12" lg="3"></b-col>
                    <b-col cols="12" md="12" lg="6">
                        <b-card>
                            <div class="card-text">
                                <app-upload-or-take-photo
                                    id="note-photos"
                                    title="Fotos de Minuta"
                                    v-model="files"
                                />
                                <div v-if="files.files && files.files.length">
                                    <button
                                        class="btn btn-sm btn-danger pull-right"
                                        @click="cancelFilesSelected"
                                    >
                                        <i
                                            class="fa fa-trash-o"
                                            aria-hidden="true"
                                        ></i>
                                        Cancelar archivos seleccionados
                                    </button>
                                </div>
                            </div>
                        </b-card>
                    </b-col>
                    <b-col cols="12" lg="3"></b-col>
                </b-row>
            </b-collapse>

            <component
                v-if="!showControlPointField"
                name="form"
                :is="theForm"
                v-model="content"
                ref="form"
            ></component>
            <div
                class="form-group"
                v-if="annotationType.slug === 'transitoria'"
            >
                <app-autocomplete
                    placeholder="Usuario asociado"
                    :items="operatives"
                    v-model="selectOperative"
                />
            </div>
            <b-form-checkbox
                v-model="sendNotification"
                v-if="annotationType.slug !== 'novedad'"
            >
                Enviar notificación a la administración del cliente
            </b-form-checkbox>
        </div>
    </div>
</template>
<script>
import notebookRepository from '../../../../repositories/notebook.repository'
import structuresRepository from '../../../../repositories/structures.repository.js'
import userRepository from '../../../../repositories/users.repository.js'
import clientAreasRepository from '../../../../repositories/client-areas.repository.js'
import incidentRiskTypesRepository from '../../../../repositories/incident-risk-types.repository.js'
import Autocomplete from '../../../UI/Controls/AutocompleteV2/Autocomplete.vue'
import AutocompleteV3 from '../../../UI/Controls/AutocompleteV3/Autocomplete.vue'
import FormDatetime from '../../../UI/Controls/Forms/FormDatetime.vue'
import FormSelectInput from '../../../UI/Controls/Forms/FormSelectInput.vue'
import { required } from 'vuelidate/lib/validators'
import NoteFormNews from './NoteForms/NoteFormNews.vue'
import NoteFormBasic from './NoteForms/NoteFormBasic.vue'
import UploadOrTakePhoto from '../../../UI/Controls/Photos/UploadOrTakePhoto.vue'
import { mapGetters } from 'vuex'
import { getCurrentPosition } from '../../../../utils/localization'
export default {
    components: {
        appNoteFormNews: NoteFormNews,
        appNoteFormBasic: NoteFormBasic,
        appAutocomplete: Autocomplete,
        appAutocompleteV3: AutocompleteV3,
        appFormDatetime: FormDatetime,
        appFormSelectInput: FormSelectInput,
        appUploadOrTakePhoto: UploadOrTakePhoto,
    },
    props: {
        onSave: Function,
        theClientId: {
            default: '',
        },
        supervisor: {
            type: Object,
            default: null,
        },
        geolocation: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            content: '',
            annotationType: '',
            form: '',
            files: '',
            clientRequired: false,
            accessPoints: [],
            accessPointId: '',
            sendNotification: false,
            operatives: [],
            selectOperative: '',
            noteDateTime: '',
            clientAreas: [],
            clientAreaId: '',
            clientAreaOther: '',
            incidentRiskTypes: [],
            incidentRiskTypeId: '',
            incidentRiskTypeOther: '',
            incidentRiskDescription: '',
        }
    },
    watch: {
        theClientId(val) {
            if (val) {
                this.loadAccessPoints()
            }
        },
        annotationType(newVal) {
            if (newVal && this.showControlPointField) {
                this.loadClientAreas()
                this.loadIncidentRiskTypes()
            } else if (!this.showControlPointField) {
                this.clientAreaId = ''
                this.clientAreaOther = ''
                this.noteDateTime = ''
                this.incidentRiskTypeId = ''
                this.incidentRiskTypeOther = ''
                this.incidentRiskDescription = ''
            }
        },
    },
    validations() {
        const baseValidations = {
            annotationType: { required },
        }
        
        if (this.showControlPointField) {
            baseValidations.incidentRiskDescription = { required }
        } else {
            baseValidations.content = { required }
        }
        
        if (this.clientRequired) {
            baseValidations.accessPointId = { required }
        }
        
        if (this.showControlPointField) {
            baseValidations.clientAreaId = { required }
            baseValidations.noteDateTime = { required }
            baseValidations.incidentRiskTypeId = { required }
            baseValidations.clientAreaOther = {
                required: (value) => {
                    if (this.clientAreaId === 'otro') {
                        return required(value)
                    }
                    return true
                }
            }
            baseValidations.incidentRiskTypeOther = {
                required: (value) => {
                    if (this.incidentRiskTypeId === 'otro') {
                        return required(value)
                    }
                    return true
                }
            }
        }
        
        return baseValidations
    },
    methods: {
        loadOperatives() {
            const ur = { ...userRepository }
            ur.getOperatives()
                .then(data => {
                    data.map(item => {
                        const operative = {
                            ...item,
                            name: item.name + ' (' + item.profile.name + ')',
                        }
                        this.operatives.push(operative)
                    })
                })
                .catch(error =>
                    toastr.error(
                        'Ocurrio un error al cargar los vigilantes y escoltas'
                    )
                )
        },
        loadAccessPoints() {
            const sr = { ...structuresRepository }
            const clientId = !!this.theClientId
                ? this.theClientId
                : !!this.client
                ? this.client.id
                : null
            if (!clientId) return
            sr.accessPointsByClient(clientId)
                .then(
                    data =>
                        (this.accessPoints = data.map(item => ({
                            ...item,
                            name: `${item.name} (Sede: ${item.venue.name})`,
                        })))
                )
                .catch(error =>
                    toastr.error(
                        'Error al cargar los puntos de acceso para las minutas'
                    )
                )
        },
        async loadClientAreas() {
            const clientId = !!this.theClientId
                ? this.theClientId
                : !!this.client
                ? this.client.id
                : null
            
            if (!clientId) {
                this.clientAreas = []
                return
            }
            
            try {
                const { data } = await clientAreasRepository.get({ clientId })
                const areas = data.data || data || []
                this.clientAreas = areas.map(item => ({
                    id: item.id,
                    name: item.venue && item.venue.name 
                        ? `${item.name} (${item.venue.name})`
                        : item.name,
                }))
            } catch (error) {
                console.error('Error al cargar las áreas del cliente:', error)
                toastr.error('Error al cargar las áreas del cliente')
                this.clientAreas = []
            }
        },
        onClientAreaChange(value) {
            this.clientAreaId = value
            this.$v.clientAreaId.$touch()
            if (value !== 'otro') {
                this.clientAreaOther = ''
                this.$v.clientAreaOther.$reset()
            }
        },
        onIncidentRiskTypeChange(value) {
            this.incidentRiskTypeId = value
            this.$v.incidentRiskTypeId.$touch()
            if (value !== 'otro') {
                this.incidentRiskTypeOther = ''
                this.$v.incidentRiskTypeOther.$reset()
            }
        },
        async loadIncidentRiskTypes() {
            const clientId = !!this.theClientId
                ? this.theClientId
                : !!this.client
                ? this.client.id
                : null
            
            if (!clientId || !this.annotationType) {
                this.incidentRiskTypes = []
                return
            }
            
            const type = this.annotationType.slug === 'incidente' ? 'incidente' : 
                        this.annotationType.slug === 'riesgo' ? 'riesgo' : null
            
            if (!type) {
                this.incidentRiskTypes = []
                return
            }
            
            try {
                const { data } = await incidentRiskTypesRepository.get({ 
                    clientId,
                    type 
                })
                const types = data.data || data || []
                this.incidentRiskTypes = types.map(item => ({
                    id: item.id,
                    name: item.name
                }))
            } catch (error) {
                console.error('Error al cargar los tipos de incidentes/riesgos:', error)
                toastr.error('Error al cargar los tipos de incidentes/riesgos')
                this.incidentRiskTypes = []
            }
        },
        buildIncidentRiskContent() {
            let content = ''
            
            if (this.noteDateTime) {
                content += `Fecha y hora: ${this.noteDateTime}\n`
            }
            
            let areaText = ''
            if (this.clientAreaId === 'otro' && this.clientAreaOther) {
                areaText = this.clientAreaOther
            } else if (this.clientAreaId && this.clientAreaId !== 'otro') {
                const selectedArea = this.clientAreasWithOther.find(area => area.id === this.clientAreaId)
                areaText = selectedArea ? selectedArea.name : ''
            }
            if (areaText) {
                content += `Área o lugar: ${areaText}\n`
            }
            
            // Tipo de incidente/riesgo
            let typeText = ''
            if (this.incidentRiskTypeId === 'otro' && this.incidentRiskTypeOther) {
                typeText = this.incidentRiskTypeOther
            } else if (this.incidentRiskTypeId && this.incidentRiskTypeId !== 'otro') {
                const selectedType = this.incidentRiskTypesWithOther.find(type => type.id === this.incidentRiskTypeId)
                typeText = selectedType ? selectedType.name : ''
            }
            if (typeText) {
                const typeLabel = this.annotationType && this.annotationType.slug === 'incidente' ? 'Tipo de Incidente' : 'Tipo de Riesgo'
                content += `${typeLabel}: ${typeText}\n`
            }
            
            if (this.incidentRiskDescription) {
                content += this.incidentRiskDescription
            }
            
            return content.trim()
        },
        cancelFilesSelected() {
            this.$bus.$emit('note-photos.clean')
            this.files = ''
            toastr.success('Archivos cancelados')
        },
        async saveNote() {
            this.$v.$touch()
            if (this.$v.$invalid) {
                toastr.error('Ingrese todos los campos')
                return false
            }

            if (!this.showControlPointField) {
                let form = this.$children.find(item => item.$attrs.name === 'form')
                if (!form || !form.isValid()) return
            }

            const formData = new FormData()

            const { latitude, longitude } = await getCurrentPosition()
            formData.append('latitude', latitude)
            formData.append('longitude', longitude)

            if (this.showControlPointField) {
                const structuredContent = this.buildIncidentRiskContent()
                formData.append('content', structuredContent)
            } else {
                formData.append('content', this.content)
            }
            formData.append('annotationTypeId', this.annotationType.id)
            formData.append(
                'userId',
                !!this.supervisor ? this.supervisor.id : this.user.id
            )
            formData.append(
                'structureId',
                !!this.clientRequired ? this.accessPointId : this.accessPoint.id
            )
            formData.append(
                'operativeId',
                !!this.selectOperative ? this.selectOperative.id : -1
            )
            formData.append('sendNotification', !!this.sendNotification ? 1 : 0)
            
            if (this.showControlPointField) {
                if (this.clientAreaId === 'otro' && this.clientAreaOther) {
                    formData.append('clientAreaOther', this.clientAreaOther)
                } else if (this.clientAreaId && this.clientAreaId !== 'otro') {
                    formData.append('clientAreaId', this.clientAreaId)
                }
                if (this.noteDateTime) {
                    formData.append('noteDateTime', this.noteDateTime)
                }
            }

            if (this.files.photos && Array.isArray(this.files.photos) && this.files.photos.length > 0) {
                this.files.photos
                    .filter(item => item && item !== null && item !== undefined)
                    .forEach(item => formData.append('photos[]', item))
            }
            if (this.files.files && Array.isArray(this.files.files) && this.files.files.length > 0) {
                this.files.files
                    .filter(item => item && item !== null && item !== undefined)
                    .forEach(item => formData.append('files[]', item))
            }

            notebookRepository
                .saveNote(formData)
                .then(data => {
                    if (data.status) {
                        toastr.success(data.msg)
                        this.cleanFields()
                        this.$bus.$emit('note-list.refresh')
                        typeof this.onSave === 'function' && this.onSave()
                    } else {
                        toastr.error(data.msg)
                    }
                })
                .catch(error => {
                    toastr.error('Ocurrió un error al guardar la minuta')
                })
        },
        fieldChange(field, value) {
            $v[field].$touch()
            this.$bus.$emit('note-update-field', field, value)
        },
        noteTypeChange(noteTypeId) {
            this.$v.annotationType.$touch()
            if (this.$v.annotationType.$invalid) {
                return false
            }

            let type = this.annotationTypes.find(
                item => item.id === parseInt(noteTypeId)
            )

            this.form = type.form
        },
        cleanFields() {
            this.$bus.$emit('note-photos.clean')
            ;(this.content = ''),
                (this.annotationType = ''),
                (this.selectOperative = ''),
                (this.accessPointId = ''),
                (this.clientAreaId = ''),
                (this.clientAreaOther = ''),
                (this.noteDateTime = ''),
                (this.incidentRiskTypeId = ''),
                (this.incidentRiskTypeOther = ''),
                (this.incidentRiskDescription = '')
            this.sendNotification = false
            this.$nextTick(() => {
                this.$v.$reset()
            })
        },
        initialize() {
            this.clientRequired = !this.user.profile.client_required
                ? true
                : false
            if (this.clientRequired) {
                this.loadAccessPoints()
            }
            this.loadOperatives()
        },
    },
    computed: {
        ...mapGetters(['annotationTypes', 'client', 'user']),
        theForm() {
            return !!this.form ? this.form : 'appNoteFormBasic'
        },
        isRiskOrIncident() {
            if (!this.annotationType) return false
            const slug = this.annotationType.slug?.toLowerCase() || ''
            const name = this.annotationType.name?.toLowerCase() || ''
            return slug === 'riesgo' || slug === 'incidente' || 
                   name.includes('riesgo') || name.includes('incidente')
        },
        showControlPointField() {
            return this.isRiskOrIncident
        },
        clientAreasWithOther() {
            const otherOption = { id: 'otro', name: 'Otro' }
            return [...this.clientAreas, otherOption]
        },
        incidentRiskTypesWithOther() {
            const otherOption = { id: 'otro', name: 'Otro' }
            return [...this.incidentRiskTypes, otherOption]
        },
    },
    created() {
        this.load('annotationTypes')
        this.initialize()
    },
    mounted() {
        this.$bus.$on('save-note', this.saveNote)
        this.$bus.$on('note-form.clean', this.cleanFields)

        if (!!this.client) {
            this.loadAccessPoints()
            if (this.showControlPointField) {
                this.loadClientAreas()
            }
        }
    },
    beforeDestroy() {
        this.$bus.$off('save-note')
        this.$bus.$off('note-form.clean')
    },
}
</script>
